"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteBookings = exports.SideBar = void 0;
var React = require("react");
var buttons_1 = require("../../buttons");
var BookingCalendar_1 = require("./BookingCalendar");
var SiteBookingSidebarPills_1 = require("./SiteBookingSidebarPills");
var BookingMessagesList_1 = require("./BookingMessagesList");
var LogisticsContractorsService_1 = require("../../../services/LogisticsContractorsService");
var LogisticsBookingService_1 = require("../../../services/LogisticsBookingService");
var CurrentSelection_1 = require("../../../services/CurrentSelection");
var LogisticsBookingMessageService_1 = require("../../../services/LogisticsBookingMessageService");
var config_1 = require("../../../config");
var SiteMapService_1 = require("../../../services/SiteMapService");
var utils_1 = require("../../../utils");
var BookingForm_1 = require("./BookingForm");
var BookingLocationService_1 = require("../../../services/BookingLocationService");
var SideBar;
(function (SideBar) {
    SideBar[SideBar["BOOKINGS"] = 0] = "BOOKINGS";
    SideBar[SideBar["MESSAGES"] = 1] = "MESSAGES";
})(SideBar = exports.SideBar || (exports.SideBar = {}));
function isBookingValid(booking, bookings) {
    var book_start = (0, config_1.moment_value)(booking.start);
    var book_end = (0, config_1.moment_value)(booking.end);
    if (book_start == undefined || book_end == undefined)
        return false;
    if (booking.resourceId == undefined)
        return false;
    if (book_end <= book_start)
        return false;
    var conflicting_bookings = bookings.filter(function (old_booking) {
        return (old_booking.id != booking.id &&
            old_booking.resourceId == booking.resourceId &&
            (0, config_1.moment_value)(old_booking.start) < book_end &&
            (0, config_1.moment_value)(old_booking.end) > book_start);
    });
    return conflicting_bookings.length == 0;
}
var SiteBookings = function (_a) {
    var project_id = _a.project_id, user = _a.user, is_admin = _a.is_admin;
    var _b = __read((0, SiteMapService_1.useSiteMapService)(project_id), 2), map_info = _b[0], siteMapService = _b[1];
    var current_map = (0, utils_1.get_first)(map_info);
    var _c = __read((0, BookingLocationService_1.useBookingLocationService)(project_id), 2), site_location_info = _c[0], locationService = _c[1];
    var _d = __read((0, LogisticsContractorsService_1.useLogisticsContractorsService)(project_id), 2), _ = _d[0], contractorService = _d[1];
    var _e = __read((0, LogisticsBookingService_1.useLogisticsBookingService)(project_id), 2), booking_event_data = _e[0], bookingService = _e[1];
    var _f = __read((0, CurrentSelection_1.useCurrentSelection)(undefined, booking_event_data.events), 2), getCurrentBooking = _f[0], setCurrentBooking = _f[1];
    var current_booking = getCurrentBooking();
    var _g = __read((0, LogisticsBookingMessageService_1.useLogisticsBookingMessageService)(project_id, current_booking && current_booking.id), 2), booking_messages_data = _g[0], bookingMessagesService = _g[1];
    var _h = __read(React.useState(SideBar.BOOKINGS), 2), sidebar = _h[0], setSidebar = _h[1];
    var _j = __read(React.useState(false), 2), show_new_message = _j[0], setShowNewMessage = _j[1];
    var _k = __read(React.useState(false), 2), show_new_booking = _k[0], setShowNewBooking = _k[1];
    React.useEffect(function () {
        siteMapService.list();
        contractorService.list();
        bookingService.list();
        locationService.list();
    }, [project_id]);
    React.useEffect(function () {
        if (sidebar == SideBar.MESSAGES && current_booking) {
            bookingMessagesService.list();
        }
    }, [project_id, current_booking, sidebar]);
    var can_message = is_admin ||
        (current_booking && user && current_booking.visitor_user_id == user.id);
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "row mt-2 mb-2", style: { height: "calc(100% - 1rem)" } },
            React.createElement("div", { className: "col-8" },
                React.createElement("div", { className: "row", style: { height: "100%" } },
                    React.createElement("div", { className: "col" },
                        React.createElement(BookingCalendar_1.BookingCalendar, { is_admin: is_admin, user: user, current_booking: current_booking, setCurrentBooking: setCurrentBooking, bookings_data: booking_event_data, bookingsSvc: bookingService, location_data: site_location_info })))),
            React.createElement("div", { className: "col-4" },
                React.createElement("div", { className: "row mb-1" }, booking_event_data.dirty_ids.length > 0 ? (React.createElement("div", { className: "col text-right" },
                    React.createElement(buttons_1.AlertButton, { onClick: function () {
                            bookingService.update_dirty();
                            setCurrentBooking(undefined);
                            setShowNewBooking(false);
                        } }, gettext("Save Changes")))) : (React.createElement(SiteBookingSidebarPills_1.SiteBookingSidebarPills, { sidebar: sidebar, setSidebar: setSidebar, newBooking: function () {
                        setCurrentBooking(undefined);
                        setShowNewBooking(true);
                    }, can_message: can_message, newMessage: function () { return setShowNewMessage(true); } }))),
                sidebar == SideBar.BOOKINGS &&
                    (current_booking || show_new_booking) &&
                    current_map && (React.createElement(BookingForm_1.BookingForm, { booking: current_booking, map_data: current_map, location_data: site_location_info, contractor_options: contractorService.getOptions(), bookingService: bookingService, cancelNewBooking: function () {
                        return setShowNewBooking(false);
                    }, changeCurrentBooking: setCurrentBooking, isBookingValid: function (booking) {
                        return isBookingValid(booking, booking_event_data.events);
                    }, is_admin: is_admin, user: user })),
                sidebar == SideBar.MESSAGES && can_message && (React.createElement(BookingMessagesList_1.BookingMessagesList, { user: user, booking: current_booking, messages: booking_messages_data.messages, bookingMessageSvc: bookingMessagesService, show_new: show_new_message, cancel_new: function () { return setShowNewMessage(false); } }))))));
};
exports.SiteBookings = SiteBookings;
